import { Offer } from '@wwt/entities/search-response'

import { saveOfferQuery } from '../query/saveOfferQuery'
import { validateOfferQuery } from '../query/validateOfferQuery'

/**
 * Function for get validated offer from server with wwtOfferId
 *
 * If offer is not saved - we save it
 * After that we check on valid
 * And after, if offer don't has an wwtOfferId - save it again
 *
 * @author Ivan Shchedrovskyi
 */
export const getValidatedOffer = async (offer: Offer) => {
	let savedOfferId = offer.IDs.wwtOfferId

	if (savedOfferId === undefined) {
		savedOfferId = (await saveOfferQuery(offer)).wwtOfferId
	}

	const validatedOffer = await validateOfferQuery(savedOfferId)

	if (validatedOffer.IDs.wwtOfferId !== undefined) {
		return {
			wwtOfferId: validatedOffer.IDs.wwtOfferId
		}
	}

	return await saveOfferQuery(validatedOffer)
}
